module.exports = __webpack_public_path__ + "media/abk/assets/images/logo-negatyw-11acb586f72accfd98a0ae481379c4f9.svg";